import { newTabLinkProps } from 'utils/newTabLinkProps'

const NOT_AVAILABLE = 'N/A'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionFiles = ({ Question, Files = [], FileTypes = [], index }) => {
  const fileTypes = FileTypes.length ? `${FileTypes.join('; ')}.` : ''

  return (
    <div className='intake-questions-item-container'>
      <div className='intake-questions-question'>
        Q{index}. {Question || ''} {fileTypes ? `File format accepted: ${fileTypes}` : null}
      </div>
      {Files?.length > 0 ?
        Files.map(({ Name, Url }) => (
          <a className='intake-questions-answer' href={Url} {...newTabLinkProps} download>
            {Name}
          </a>
        ))
      : '--'}
    </div>
  )
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionBodyMeasurement = ({ HeightInches, index, WeightPounds }) => {
  const heightFeet = HeightInches ? Math.floor(HeightInches / 12) : 0
  const remainingInches = HeightInches ? HeightInches % 12 : 0
  const weight = WeightPounds || 0

  return (
    <div className='intake-questions-item-container'>
      <div className='intake-questions-question'>Q{index}. Body Measurements</div>

      <div className='intake-questions-sub-question'>How tall are you?</div>
      <div className='intake-questions-answer'>
        {heightFeet}&apos; {remainingInches}
      </div>

      <div className='intake-questions-sub-question'>What is your current weight?</div>
      <div className='intake-questions-answer'>{weight}lbs</div>
    </div>
  )
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionCondition = ({ Option, Question, InputValue, index }) => (
  <div className='intake-questions-item-container'>
    <div className='intake-questions-question'>
      Q{index}. {Question}
    </div>

    <div className='intake-questions-answer'>{Option}</div>

    {InputValue ?
      <div className='intake-questions-answer'>{InputValue}</div>
    : null}
  </div>
)

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionStatement = ({ Question, index }) => (
  <div className='intake-questions-item-container'>
    <div className='intake-questions-question'>
      Q{index}. {Question}
    </div>
    <div className='intake-questions-answer'>{NOT_AVAILABLE}</div>
  </div>
)

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionTextBox = ({ Question, Text, index }) => (
  <div className='intake-questions-item-container'>
    <div className='intake-questions-question'>
      Q{index}. {Question}
    </div>
    <div className='intake-questions-textbox-answer'>{Text ?? '--'}</div>
  </div>
)

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionEmail = ({ Question, Email, index }) => (
  <div className='intake-questions-item-container'>
    <div className='intake-questions-question'>
      Q{index}. {Question}
    </div>
    <div className='intake-questions-answer'>{Email ?? '--'}</div>
  </div>
)

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionOptions = ({ Question, Options, index }) => (
  <div className='intake-questions-item-container'>
    <div className='intake-questions-question'>
      Q{index}. {Question}
    </div>
    <div className='intake-questions-answer'>
      {/*
       // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
      {Options.length ? Options.map((name, optionIndex) => (optionIndex === 0 ? name : `; ${name}`)) : '--'}
    </div>
  </div>
)
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const QuestionPharmacySelection = ({ Question, index, Name, Address }) => (
  <div className='intake-questions-item-container'>
    <div className='intake-questions-question'>
      Q{index}. {Question}
    </div>
    <div className='intake-questions-textbox-answer'>{Name ? `${Name} - ${Address}` : '--'}</div>
  </div>
)
